import { Map as MapLib, MapLayerMouseEvent } from "maplibre-gl";
import { mapManager } from "../globals";
import { PRIVATEDATA_SOURCE } from "./private-data-manager";

export class InteractionManager {
  private hovered: string | null = null;

  /**
   * Set the styling for features in a layer on hover
   */
  public addHoverEffects = (map: MapLib) => {
    // on hover set styles
    const onMove = (e: MapLayerMouseEvent) => {
      const [site] = map.queryRenderedFeatures(e.point);

      // clear the state for features that isn't hovered
      if (this.hovered) {
        mapManager.removeFeatureState({
          id: this.hovered,
          source: PRIVATEDATA_SOURCE,
        });
      }

      if (!site) {
        map.getCanvas().style.cursor = "";
        return;
      }

      mapManager.setFeatureState(
        {
          id: site.id,
          source: PRIVATEDATA_SOURCE,
        },
        {
          hover: true,
        },
      );

      map.getCanvas().style.cursor = "pointer";
      this.hovered = site.id as string;
    };

    map.on("mousemove", onMove);

    return () => {
      map.off("mousemove", onMove);
    };
  };
}
